import { useBids } from '@reservoir0x/reservoir-kit-ui'
import { BaseMultichainProps } from 'hooks/liquidity/mergeLiquidity.interface'
import { getContractIdForSystemAndChainKey } from 'utils/multichain'
import { useMergeChainDataEffect } from 'hooks/liquidity/useMergeChainDataEffect'

export const MultichainBids = ({
  tokenId,
  collection,
  systemId,
  onDataFetched,
}: BaseMultichainProps<any[]>) => {
  const chainId = collection?.id
  const contractId = getContractIdForSystemAndChainKey(
    systemId,
    collection.routePrefix
  )
  const {
    data: offers,
    isLoading,
    error,
  } = useBids(
    {
      token: `${contractId}:${tokenId ?? ''.toString()}`,
      includeRawData: true,
      sortBy: 'price',
      limit: 1,
    },
    {},
    true,
    chainId
  )

  useMergeChainDataEffect({ data: offers, isLoading, error, onDataFetched })

  return null
}
